import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IfaListContainerComponent } from '@ifa/ifa-list-container/ifa-list-container.component';

@Component({
  selector: 'app-ifa-confirmation',
  templateUrl: './ifa-confirmation.component.html',
  styleUrls: ['./ifa-confirmation.component.scss']
})
export class IfaConfirmationComponent implements OnInit {

  tagName : string;

  constructor( public dialogRef: MatDialogRef<IfaListContainerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      this.tagName = data.tag.tagName
     }

  ngOnInit() {
  }

  public onConfirmation(status: boolean, data?: any) {
    const response = { status, data };
    this.dialogRef.close(response);
  }

}
